/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  TwoFactorDisableRequest,
  TwoFactorEnableRequest,
  TwoFactorRegenerateRequest,
  UsersTwoFactorEnableCreate200,
  UsersTwoFactorSetupCreate200
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Disable two-factor authentication. Requires the current password **and** a valid TOTP code so a stolen session alone cannot strip 2FA off the account.
 * @summary Disable 2FA
 */
export const usersTwoFactorDisableCreate = (
    twoFactorDisableRequest: TwoFactorDisableRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/users/twoFactor/disable/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorDisableRequest
    },
      );
    }
  


export const getUsersTwoFactorDisableCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorDisableCreate>>, TError,{data: TwoFactorDisableRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorDisableCreate>>, TError,{data: TwoFactorDisableRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersTwoFactorDisableCreate>>, {data: TwoFactorDisableRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersTwoFactorDisableCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersTwoFactorDisableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersTwoFactorDisableCreate>>>
    export type UsersTwoFactorDisableCreateMutationBody = TwoFactorDisableRequest
    export type UsersTwoFactorDisableCreateMutationError = void

    /**
 * @summary Disable 2FA
 */
export const useUsersTwoFactorDisableCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorDisableCreate>>, TError,{data: TwoFactorDisableRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersTwoFactorDisableCreate>>,
        TError,
        {data: TwoFactorDisableRequest},
        TContext
      > => {

      const mutationOptions = getUsersTwoFactorDisableCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Verify the first TOTP code against the pending secret, commit it, and issue a fresh batch of one-time recovery codes. Recovery codes are returned **only here** — they are stored hashed and cannot be re-fetched.
 * @summary Enable 2FA
 */
export const usersTwoFactorEnableCreate = (
    twoFactorEnableRequest: TwoFactorEnableRequest,
 ) => {
      
      
      return customInstance<UsersTwoFactorEnableCreate200>(
      {url: `/api/v1/users/twoFactor/enable/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorEnableRequest
    },
      );
    }
  


export const getUsersTwoFactorEnableCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorEnableCreate>>, TError,{data: TwoFactorEnableRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorEnableCreate>>, TError,{data: TwoFactorEnableRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersTwoFactorEnableCreate>>, {data: TwoFactorEnableRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersTwoFactorEnableCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersTwoFactorEnableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersTwoFactorEnableCreate>>>
    export type UsersTwoFactorEnableCreateMutationBody = TwoFactorEnableRequest
    export type UsersTwoFactorEnableCreateMutationError = void

    /**
 * @summary Enable 2FA
 */
export const useUsersTwoFactorEnableCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorEnableCreate>>, TError,{data: TwoFactorEnableRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersTwoFactorEnableCreate>>,
        TError,
        {data: TwoFactorEnableRequest},
        TContext
      > => {

      const mutationOptions = getUsersTwoFactorEnableCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Replace the user's recovery codes with a fresh batch. Requires a current TOTP code (proof of possession) and invalidates every previously-issued code.
 * @summary Regenerate recovery codes
 */
export const usersTwoFactorRecoveryCodesRegenerateCreate = (
    twoFactorRegenerateRequest: TwoFactorRegenerateRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/users/twoFactor/recoveryCodes/regenerate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorRegenerateRequest
    },
      );
    }
  


export const getUsersTwoFactorRecoveryCodesRegenerateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorRecoveryCodesRegenerateCreate>>, TError,{data: TwoFactorRegenerateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorRecoveryCodesRegenerateCreate>>, TError,{data: TwoFactorRegenerateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersTwoFactorRecoveryCodesRegenerateCreate>>, {data: TwoFactorRegenerateRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersTwoFactorRecoveryCodesRegenerateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersTwoFactorRecoveryCodesRegenerateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersTwoFactorRecoveryCodesRegenerateCreate>>>
    export type UsersTwoFactorRecoveryCodesRegenerateCreateMutationBody = TwoFactorRegenerateRequest
    export type UsersTwoFactorRecoveryCodesRegenerateCreateMutationError = void

    /**
 * @summary Regenerate recovery codes
 */
export const useUsersTwoFactorRecoveryCodesRegenerateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorRecoveryCodesRegenerateCreate>>, TError,{data: TwoFactorRegenerateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersTwoFactorRecoveryCodesRegenerateCreate>>,
        TError,
        {data: TwoFactorRegenerateRequest},
        TContext
      > => {

      const mutationOptions = getUsersTwoFactorRecoveryCodesRegenerateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Generate (or regenerate) a TOTP secret pending verification. Returns the base32 secret, an `otpauth://` provisioning URI, and a base64 PNG QR code. The secret is only committed once the user calls `/twoFactor/enable` with a valid code.
 * @summary Begin 2FA setup
 */
export const usersTwoFactorSetupCreate = (
    
 ) => {
      
      
      return customInstance<UsersTwoFactorSetupCreate200>(
      {url: `/api/v1/users/twoFactor/setup/`, method: 'POST'
    },
      );
    }
  


export const getUsersTwoFactorSetupCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorSetupCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorSetupCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersTwoFactorSetupCreate>>, void> = () => {
          

          return  usersTwoFactorSetupCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersTwoFactorSetupCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersTwoFactorSetupCreate>>>
    
    export type UsersTwoFactorSetupCreateMutationError = void

    /**
 * @summary Begin 2FA setup
 */
export const useUsersTwoFactorSetupCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersTwoFactorSetupCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersTwoFactorSetupCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUsersTwoFactorSetupCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    